import { useState } from "react";
import { Button } from "react-bootstrap";
import { ToastContainer } from "react-toastify";
import SideNavbar from "../../components/common/SideNavbar";
import TopNavbar from "../../components/common/TopNavbar";
import GenericCrudPanel from "../../components/common/crud/GenericCrudPanel";

const HR_BASE = `${process.env.REACT_APP_BACKEND_API_URL}/hr`;

const HOLIDAY_TYPE_OPTIONS = [
  { value: "PUBLIC", label: "Public" },
  { value: "RESTRICTED", label: "Restricted" },
  { value: "COMPANY", label: "Company" },
];

const MODULE = {
  key: "holiday",
  title: "Holidays",
  endpoint: "/holiday/",
  fields: [
    { name: "name", label: "Name", required: true },
    { name: "date", label: "Date", required: true, type: "date" },
    { name: "holiday_type", label: "Holiday Type", required: true, type: "select", optionsKey: "holidayTypeOptions" },
    { name: "year", label: "Year", required: true, type: "number" },
    { name: "description", label: "Description", type: "textarea" },
  ],
  columns: [
    { name: "Name", selector: (row) => row.name || "-", sortable: true },
    { name: "Date", selector: (row) => row.date || "-", sortable: true },
    { name: "Type", selector: (row) => row.holiday_type || "-", sortable: true },
    { name: "Year", selector: (row) => row.year || "-", sortable: true },
  ],
  initialForm: { name: "", date: "", holiday_type: "PUBLIC", year: new Date().getFullYear(), description: "" },
};

async function loadOptions() {
  return { holidayTypeOptions: HOLIDAY_TYPE_OPTIONS };
}

function HolidayMaster() {
  const [menuDrawerShow, setMenuDrawerShow] = useState(true);
  const [dataFromTopNavBar, setDataFromTopNavBar] = useState("");

  const handleDataFromTopNavBar = (permissiondata) => {
    setDataFromTopNavBar(permissiondata);
  };

  return (
    <div className="page-content-bg">
      <TopNavbar sidebarCollapsed={menuDrawerShow} topNavbarStatic={true} sendDataToParent={handleDataFromTopNavBar} />
      <SideNavbar
        sidebarCollapsed={menuDrawerShow}
        activeMenu="Master"
        activeSubMenu="HolidayMaster"
        activeSubMenuLevel1=""
        permissionFromTopNavbar={dataFromTopNavBar}
      />

      <div className={menuDrawerShow ? "row main-content-collapsed text-left py-0" : "row main-content text-left py-0"}>
        <div className="col-12 page-header">
          <div className="row">
            <div className="col-sm-6 py-1">
              <Button className="btn btn-sm btn-inox-green border-0 mx-2" onClick={() => setMenuDrawerShow(!menuDrawerShow)}>
                {menuDrawerShow ? <span><i className="fa fa-chevron-left mx-1"></i></span> : <span><i className="fa fa-chevron-right mx-1"></i></span>}
              </Button>
              <span className="page-header-text">Holiday Master</span>
            </div>
          </div>
        </div>

        <div className="col-12 text-left" style={{ marginTop: -5, paddingLeft: 20, paddingRight: 30 }}>
          <GenericCrudPanel module={MODULE} baseUrl={HR_BASE} loadOptions={loadOptions} />
        </div>
      </div>

      <ToastContainer />
    </div>
  );
}

export default HolidayMaster;
